import React from 'react';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import type { ReviewStage } from '../../types';

type Props = {
  reviewStages: ReviewStage[];
  selectedStageId?: number | null;
  onChange: (stageId: number) => void;
  ariaLabel: string;
  'data-provides': string;
};

// The review stage dropdown shared by the App Review tab and the job dashboard widget.
const ReviewStageDropdown = ({
  reviewStages,
  selectedStageId,
  onChange,
  ariaLabel,
  'data-provides': dataProvides,
}: Props) => {
  const items = reviewStages.map((stage) => ({
    label: stage.name,
    value: stage.id,
  }));
  const selectedItem =
    items.find((item) => item.value === selectedStageId) ?? items[0];

  return (
    <SimpleSingleDropdown<number>
      data-provides={dataProvides}
      ariaLabel={ariaLabel}
      items={items}
      selectedItem={selectedItem}
      onSelectedItemChange={(item) => item && onChange(item.value)}
      clearable={false}
    />
  );
};

export default ReviewStageDropdown;
